import { useMutation } from '@tanstack/react-query';
import { Col, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import { GrossProfitApis } from 'apis/GrossProfitApis';
import { PlantApi } from 'apis/PlantApis';
import { FormFilter, InputForm, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectParams,
} from 'components/Select/LazySelectForm';
import { useUser } from 'contexts/UserProvider';
import Content from 'layouts/Content';
import { useEffect, useState } from 'react';

interface IProps {
  isOpen: boolean;
  defaultFilter: any;
  onCancel: () => void;
  onFinish: (values: any) => void;
}

const spanCol = 8;
const FilterGrossProfit = (props: IProps) => {
  const { isOpen, defaultFilter, onCancel, onFinish } = props;
  const { user } = useUser();
  const [form] = useForm();
  const [optionsAge, setOptionsAge] = useState<any>({});
  const [plants, setPlants] = useState<DefaultOptionType[]>([]);

  const { mutate: getAllPlant, isPending: getAllPlantLoading } = useMutation({
    mutationFn: () => PlantApi.getAllPlantFilterHO(),
    onSuccess: (data: any) => {
      const items = data.data?.getPlant?.items || [];

      if (!items?.length) return setPlants([]);

      const plants = items.map((item: any) => ({
        label: item.id,
        value: item.id,
      }));

      setPlants(plants);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: mutateGetCbxAge, isPending: isPendingGetCbxAge } =
    useMutation({
      mutationFn: GrossProfitApis.getAgeComboBox,
      onSuccess: (res) => {
        const data = res?.data?.getProduct?.items || [];

        if (data.length === 0) return;

        setOptionsAge({
          items: data.map((item: any) => ({
            label: item.age,
            value: item.age,
          })),
          pageInfo: res.data?.getProduct.pageInfo,
        });
      },
    });

  const handleAgeSelectScrollChange = (params: ILazySelectParams) => {
    mutateGetCbxAge({
      skip: 0,
      take: params.pageSize,
      age: params.value !== undefined ? Number(params.value) : undefined,
    });
  };

  const handleCancel = () => {
    form.resetFields();
    form.setFieldsValue(defaultFilter);

    onCancel();
  };

  useEffect(() => {
    getAllPlant();
  }, [getAllPlant]);

  useEffect(() => {
    form.setFieldsValue(defaultFilter);
  }, [defaultFilter, form]);

  return (
    <Content isOpen={isOpen}>
      <FormFilter form={form} onFinish={onFinish} onCancel={handleCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Chi nhánh" name="plantId">
              <SelectForm
                loading={getAllPlantLoading}
                options={[
                  {
                    label: 'Tất cả chi nhánh',
                    value: 'all',
                  },
                  ...plants,
                ]}
                disabled={!(user?.isAdmin || user?.isHO)}
                placeholder="Chọn chi nhánh"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Chủng loại"
              name="type"
              rules={[
                { required: true, message: 'Chủng loại không được để trống' },
              ]}
            >
              <InputForm placeholder="Nhập chủng loại" />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Tuổi vàng" name="age">
              {/* <SelectForm
                options={optionsGoldAge}
                placeholder="Chọn tuổi vàng"
              /> */}
              <LazySelectForm
                customeSize={20}
                data={{
                  options: optionsAge.items || [],
                  totalItems: optionsAge.pageInfo?.totalItems || 0,
                }}
                loading={isPendingGetCbxAge}
                placeholder="Chọn tuổi vàng"
                onSelectScrollChange={handleAgeSelectScrollChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterGrossProfit;
